import { render, staticRenderFns } from "./TractCostDetail.vue?vue&type=template&id=244ad402&"
import script from "./TractCostDetail.vue?vue&type=script&lang=js&"
export * from "./TractCostDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports